import React from 'react';

import HStack from './hstack';

export default React.memo(HStack);
